import { useCallback, useState } from 'react';
import { useAppSelector } from '../../../redux/hook';
import { P2Accordion, P2Alert, P2TextDescription } from 'react-bootstrap-common-script';
import SignifyDocumentItem from '../component/signify-document-component';
import { Separator } from '../../../components/separator';

interface PhysicalFormAccordionProps {
  forms: [];
}

const PhysicalFormAccordion = ({ forms }: PhysicalFormAccordionProps) => {
  // Redux dispatch and selectors
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);

  // Local component state
  const [accordionSubtitle, setAccordionSubtitle] = useState<boolean>(true);

  // Toggle the accordion subtitle when called.
  const handleAccordionSubtitle = useCallback(() => {
    setAccordionSubtitle((prev) => !prev);
  }, [forms]);

  const hasForms = forms && forms.length > 0;
  return (
    <div className='polymer-stage-e-accordion'>
      <P2Accordion
        defaultOpen={true}
        hasDivider={true}
        onToggle={handleAccordionSubtitle}
        title={
          <div className='polymer-accordion-listing_title'>
            <div className='polymer-accordion-listing_title_wrap'>
              <h4>2. Documents for review</h4>
            </div>
            {(accordionSubtitle && hasForms) && (
              <div className='polymer-stage-e-accordion-subtitle'>
                <P2TextDescription
                  color='#333'
                  description={
                    'You may review the following documents before your appointment. All owners will need to sign these documents during the completion appointment.  '
                  }
                />
              </div>
            )}
          </div>
        }>
        {/* Accordion's Content Starts Here --- */}
        {hasForms ? (
          <div className='d-flex flex-column' style={{ marginTop: '16px' }}>
            {forms.map((item: any, index: number) => {
              const isFirst = index === 0;
              return (
                <div key={index}>
                  {isFirst ? null : <Separator style={{ margin: '16px 0' }} />}

                  <SignifyDocumentItem
                    form_name={item.title}
                    form_link={item.signing_link}
                    form_endorsement_date={item.signify_status === 'signed' ? item.lastSignedDate : ''}
                    form_signify_status={item.signify_status}
                    isSigningRequire={item.signing_require}
                    formData={item?.form_data ?? undefined}
                    singpassToken={singpassToken}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className='polymer-stage-e-document-items'>
            <P2Alert variant={'info'} withBorder={true} text={'No documents for review.'} />
          </div>
        )}
      </P2Accordion>
    </div>
  );
};

export default PhysicalFormAccordion;
